module.exports = __webpack_public_path__ + "static/waye-logo-white-large-6b8b0f1e7fda09415c015565c30bc4e4.png";